module.exports = __webpack_public_path__ + "static/media/img-reservation.1a26a5ad.png";